module.exports = __webpack_public_path__ + "img/process_icon2.2caad2f1.png";